window.formatMoney = function(t, e) {
  var a = "${{amount}}"
  "string" === typeof t && (t = t.replace(".", ""));
  var r = "",
      o = /\{\{\s*(\w+)\s*\}\}/,
      n = e || a;
  function formatWithDelimiters(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ",",
          a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".";
      if (isNaN(t) || null == t) return 0;
      var o = (t = (t / 100).toFixed(e)).split(".");
      return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(r)) + (o[1] ? a + o[1] : "");
  }
  switch (n.match(o)[1]) {
      case "amount":
          r = formatWithDelimiters(t, 2);
          break;
      case "amount_no_decimals":
          r = formatWithDelimiters(t, 0);
          break;
      case "amount_with_comma_separator":
          r = formatWithDelimiters(t, 2, ".", ",");
          break;
      case "amount_no_decimals_with_comma_separator":
          r = formatWithDelimiters(t, 0, ".", ",");
  }
  return n.replace(o, r);
}